import md5 from 'md5';

/**
 * will take input an array of strings and return hash (md5) value
 * @param {array} input
 */
export const md5Array = (input = []) => md5(input.join());

export default md5Array;
